import React, { Component } from 'react';
import { isEmpty, get, cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { PERMISSION } from '../../../constants/permission';
import { checkTablePermission, checkAddPermission } from '../../../utils/route-auth';

import Table from '../../../components/CustomTable';
import ModalConfirmation from '../../../components/ModalConfirmation';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import routes from '../../../routes';

import {
    // getOptimizerListAction,
    getListAdvertiserAction,
    getAllCampaignListAction,
    getAllListAdminMarginAction
} from '../../../actions';

import { optionsListData, formFields } from './constant';
import Select from "react-select";



const Card = asyncRoute(() => import('../../../components/Card'));
const BreadCrumb = asyncRoute(() => import('../../../components/BreadCrumb'));

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            advertiserListData: [],
            submited: false,
            form: {},
            touched: {},
            errors: {},
            advertiserList: [],
            selectedData: [],
            roStatus: [],
            statusData: {},
            roNamesData: {},
            filteredTableData: [],
            confirmationOpen: false,
            confirmationInfo: '',
            allMarginData: [],
            campaignList: [],
            filterListAdvertiser: {},
            filterListCampaign: {},
            campaignListData: [],
            marginList: [],
            ListOriginalData: [],
            optionsList: optionsListData

        };
    }



    // eslint-disable-next-line no-unused-react-component-methods/no-unused-react-component-methods
    async componentWillMount() {
        const { history } = this.props;

        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));

        let optionsList = checkTablePermission({ add: PERMISSION.ADMINMARGIN.ADMINMARGIN.ADD, edit: PERMISSION.ADMINMARGIN.ADMINMARGIN.EDIT }, cloneDeep(optionsListData));

        this.setState({ optionsList });


        if (isEmpty(isAuthenticated)) {
            history.push(routes.preSignIn);
        }
        await this.AdvertiserApi();
        await this.AllCampaignApi();
        await this.allListAPI();
    }


    AdvertiserApi = async () => {
        const { history, tenantId, authToken, userId, getListAdvertiserAction } = this.props;
        const {
            responseCode: { status = "" },
            response,
        } = await getListAdvertiserAction({ tenantId, authToken, userId });
        if (status == "Success") {
            const advertiserListData = response.advertisers.map((item, index) => {
                return { label: item.value, value: item.id, name: "advertiser" };
            });
            this.setState({ advertiserList: advertiserListData });
        }
    }


    AllCampaignApi = async () => {
        const { history, tenantId, authToken, userId, getAllCampaignListAction } = this.props;
        const {
            responseCode: { status = "" },
            responseList,
        } = await getAllCampaignListAction({ tenantId, authToken, userId });
        if (status == "Success") {
            const data = responseList.map((item) => {
                return { label: item.name, value: item.name, name: "campaign", tenantId: item.tenantId }
            });
            this.setState({ campaignList: data, campaignListData: data });
        }
    }

    async allListAPI() {
        const { history, tenantId, authToken, userId, getAllListAdminMarginAction } = this.props;
        const {
            responseCode: { status = "" },
            responseList,
        } = await getAllListAdminMarginAction({ tenantId, authToken, userId });
        if (status == "Success") {
            // console.log(responseList, "outputMedia")
            const data = responseList;
            this.setState({ ListOriginalData: data })
            this.setState({ allMarginData: data, marginList: data });
        }
    }

    handleFilterChange = (selected) => {
        const { campaignList, campaignListData } = this.state;
        if (selected.name == "advertiser") {
            this.setState({ filterListAdvertiser: selected })
            const filterCampaign = campaignList.filter(item => item.tenantId === selected.value);
            this.setState({ campaignListData: filterCampaign, filterListCampaign: {} });
        }

        if (selected.name == "campaign") {
            this.setState({ filterListCampaign: selected })
        }
    }

    handleAction = (row, action) => {
        const { match, history } = this.props;
        if (action.type === 'edit') {
            this.handleEdit(row, match, history);
        }
    };

    handleEdit = (row, match, history) => {
        history.push(`${match.path}/${routes.adminMargin.editAdminMargin}/${row.id}`)

        // console.log(row,"row",match,"match", history)
    }


    toggleModal = (confirmation) => {
        const { confirmationOpen } = this.state;
        this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation });
    };

    // eslint-disable-next-line no-unused-vars
    confirmationCallBack = (success, info) => {
        this.setState({ confirmationOpen: false });
    };

    // handleApply = (e) => {
    //     e.preventDefault();
    //     const { campaignList, allMarginData, filterListCampaign, campaignListData, marginList, filterListAdvertiser } = this.state;
    //     if (filterListCampaign.value == undefined) {
    //         const filterData = marginList.filter(item => item.tenantId === filterListAdvertiser.value);
    //         this.setState({ allMarginData: filterData })
    //     } else {
    //         const filteredCampaign = marginList.filter(item => item.campaignName === filterListCampaign.value);
    //         this.setState({ allMarginData: filteredCampaign })
    //     }
    // }

    handleApply = (e) => {
        e.preventDefault();
        const { campaignList, allMarginData, filterListCampaign, campaignListData, marginList, filterListAdvertiser } = this.state;

        if (filterListCampaign.value == undefined && filterListAdvertiser.value == undefined) 
        {
          // Handle case where neither campaign nor advertiser is selected
        }

        else if (filterListCampaign.value == undefined) {
            const filterData = marginList.filter(item => item.tenantId === filterListAdvertiser.value);
            this.setState({ allMarginData: filterData })
        } else {
            const filteredCampaign = marginList.filter(item => item.campaignName === filterListCampaign.value); 
            this.setState({ allMarginData: filteredCampaign })
        }
    }

    handleReset = async (e) => {
        e.preventDefault();
        this.setState({ filterListCampaign: {}, filterListAdvertiser: {} })
        this.setState({ allMarginData: this.state.ListOriginalData });
    }

    // ====================== advertiser filter api =================

    render() {
        const { match, ioListAll, configurationList } = this.props;
        const { confirmationOpen, confirmationInfo, campaignList, allMarginData, advertiserList, campaignListData, filterListCampaign, filterListAdvertiser, optionsList } = this.state;
        console.log("filterListCampaign", filterListCampaign);
        return (
            <>
                {confirmationOpen && (<ModalConfirmation
                    open={confirmationOpen}
                    onClose={this.toggleModal}
                    confirmationInfo={confirmationInfo}
                    handelConfirmationMessage={this.confirmationCallBack}
                />)}
                <div className="main-panel ion">
                    <div className="content-wrapper">
                        <BreadCrumb />
                        <div className="row mt-3">
                            <Card>
                                {
                                    (checkAddPermission(PERMISSION.ADMINMARGIN.ADMINMARGIN.ADD)) && (
                                        <div className="margin-list-adj">
                                            <Link to={`${match.path}/${routes.adminMargin.addAdminMargin}`}> <button className="btn btn-primary"><i className="mdi mdi-plus"></i>Admin Margin</button></Link>
                                        </div>
                                    )

                                }


                                    <div class="accordion my-3" id="accordionWithIcon">
                                        <div class="card accordion-item mb-2">
                                        <h2 class="accordion-header d-flex align-items-center">
                                            <button type="button" class="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionWithIcon-1" aria-expanded="true">
                                            <i class="ti ti-filter ti-xs me-2"></i>
                                            Filter Admin Margin
                                            </button>
                                        </h2>

                                        <div id="accordionWithIcon-1" class="accordion-collapse collapse show" >
                                            <div class="accordion-body pb-0">
                                            <div className="row">
                                                <div className="col-md-12 grid-margin">
                                                    <div className='row'>
                                                        <div className='col-md-4'>
                                                            <label className='pl-1' style={{fontSize:'14px'}}>Select Advertiser :</label>
                                                            <Select
                                                                options={advertiserList}
                                                                defaultValue={Object.keys(filterListAdvertiser).length === 0 ? "" : filterListAdvertiser}
                                                                value={Object.keys(filterListAdvertiser).length === 0 ? "" : filterListAdvertiser}
                                                                onChange={(selected) => this.handleFilterChange(selected)}
                                                                placeholder="--Select--"
                                                            />
                                                        </div>
                                                        <div className='col-md-4'>
                                                            <label className='pl-1' style={{fontSize:'14px'}}>Select Campaigns :</label>
                                                            <Select
                                                                options={campaignListData}
                                                                defaultValue={Object.keys(filterListCampaign).length === 0 ? "" : filterListCampaign}
                                                                value={Object.keys(filterListCampaign).length === 0 ? "" : filterListCampaign}
                                                                // defaultValue={selectedData.value ? selectedData.value : roListNames.length > 0 ? inititalStatus : { label: "All", value: "All Status" }}
                                                                onChange={(selected) => this.handleFilterChange(selected)}
                                                                placeholder="--Select--"
                                                            />
                                                        </div>
                                                        <div className="col-md-4 d-flex align-items-end filter-action-adj">
                                                            <button onClick={(e) => this.handleApply(e)} className="btn btn-primary h4 p-2"><i className='mdi mdi-account-check'></i>Apply</button>
                                                            <button onClick={(e) => this.handleReset(e)} className="btn btn-primary h4 ml-4 p-2"><i class="mdi mdi-replay"></i>Reset</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>



                                {/* <div className="row">
                                    <div className="col-md-12 grid-margin">
                                        <div className='row'>
                                            <div className='col-md-4'>
                                                <label className='pl-1' style={{fontSize:'14px'}}>Select Advertiser :</label>
                                                <Select
                                                    options={advertiserList}
                                                    defaultValue={filterListAdvertiser}
                                                    value={filterListAdvertiser}
                                                    onChange={(selected) => this.handleFilterChange(selected)}
                                                    placeholder="--Select--"
                                                />
                                            </div>
                                            <div className='col-md-4'>
                                                <label className='pl-1' style={{fontSize:'14px'}}>Select Campaigns :</label>
                                                <Select
                                                    options={campaignListData}
                                                    defaultValue={filterListCampaign}
                                                    value={filterListCampaign}
                                                    // defaultValue={selectedData.value ? selectedData.value : roListNames.length > 0 ? inititalStatus : { label: "All", value: "All Status" }}
                                                    onChange={(selected) => this.handleFilterChange(selected)}
                                                    placeholder="--Select--"
                                                />
                                            </div>
                                            <div className="col-md-4 d-flex align-items-end filter-action-adj">
                                                <button onClick={(e) => this.handleApply(e)} className="btn btn-primary h4 p-2"><i className='mdi mdi-account-check'></i>Apply</button>
                                                <button onClick={(e) => this.handleReset(e)} className="btn btn-primary h4 ml-4 p-2"><i class="mdi mdi-replay"></i>Reset</button>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            {/* </Card> */}




                            {/* <Card> */}
                                <div className="table-responsive">
                                    <Table
                                        options={optionsList}
                                        data={allMarginData}
                                        handelAction={this.handleAction}
                                    />
                                </div>
                            </Card>
                        </div>
                    </div>
                </div >
            </>
        );
    }
}

export default withRouter(connect(
    state => ({
        getUserPermissionList: get(state, 'app.getUserPermissionList', []),
        configurationList: get(state, 'app.configurationData.responseList', []),
        ioListAll: get(state, 'app.ioListAllReport.responseList', []),
        tenantId: get(state, 'app.preSignInState.tenantId', ''),
        userId: get(state, 'app.preSignInData.userId', ''),
        authToken: get(state, 'app.signInData.authToken', '')
    }),
    {
        // getIoListAllReportAction,
        // deleteIoAction,
        // getIoEditIdReportAction,
        // addIoReportAction,
        // roListAction,
        // roListNamesAction,
        getListAdvertiserAction,
        getAllCampaignListAction,
        getAllListAdminMarginAction
    }
)(index));

// ----*  IO propTypes * ----
index.propTypes = {
    configurationList: PropTypes.array,
    ioListAll: PropTypes.array,
    tenantId: PropTypes.number,
    userId: PropTypes.number,
    authToken: PropTypes.string,
    getIoListAllReportAction: PropTypes.func,
    deleteIoAction: PropTypes.func,
};